export default function isBuffer(value) {
    // @ts-ignore
    return !!value?.constructor?.isBuffer?.(value);
}
;
